import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsiteChecklist = () => {
	const classes = useStyles("Website");

	const backgroundColor = "#ffebe5"; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = `https://wallpapercave.com/wp/wp8377155.jpg`; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = true;

	const columns = "2"; // 1, 2 , 3 , 4
	const header = `Benefits of Yoga for Children`;
	const subHeader = `Where Your Child's Path to Success Begins`;
	const tagline = "Our Proprietary Reggio Emilia- Inspired Curriculum";
	const textAlign = "center"; // left / center / right
	const lineBreak = true;
	const content = "";

	const button = "Learn more";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "Secondary";
	const buttonSecondaryLink = "/wesbite/about-us";

	const items = [
		{
			detail:
				"Yoga provides a physical, mental, and emotional outlet to release pent up stress, fear, and anxiety.",
		},
		{
			detail:
				"Breath work helps with relaxation, better sleep, increased memory, and it boosts energy levels.",
		},
		{
			detail:
				"Yoga helps with overall wellness. It stimulates the lymph glands, and has a positive effect on the hormones and the nervous system.",
		},
		{
			detail:
				"Yoga helps with a child’s perception of senses, control of movement, and emotional validation.",
		},
		{
			detail:
				"It gives kids a positive and fun environment to develop strength and flexibility.",
		},
		{
			detail: "Certain games and poses help build memory and increase focus.",
		},
		{
			detail:
				"Yoga classes provide a safe space for kids to discuss emotions they are experiencing, and learn strategies for how to deal with them.",
		},
		{
			detail:
				"Kids will learn about empathy, gratitude, and living in the present moment.",
		},
		{
			detail: "Students are able to develop greater balance and coordination.",
		},
		{
			detail:
				"Yoga gives kids a chance to practice stillness and meditation. This skill will continue to develop with practice and time.",
		},
	];

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							justifyContent="center"
							alignItems={textAlign}
						>
							<Grid item xs={12}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									alignItems={textAlign}
									height={"100%"}
								>
									{tagline && (
										<Box className="tagline" textAlign={textAlign}>
											{tagline}
										</Box>
									)}

									{header && (
										<Box component={"h2"} textAlign={textAlign}>
											{header}
										</Box>
									)}

									{subHeader && (
										<Box component={"h3"} textAlign={textAlign}>
											{subHeader}
										</Box>
									)}

									{lineBreak && (
										<Box my={1} textAlign={textAlign}>
											<LineBreak className={classes.lineBreak} />
										</Box>
									)}

									{content && (
										<>
											<Box component={"p"} textAlign={textAlign}>
												{content}
											</Box>
										</>
									)}

									<Box my={6}>
										<Grid container spacing={10}>
											{items.map((item) => (
												<Grid
													item
													xs={12}
													md={
														columns === "1"
															? 12
															: columns === "2"
															? 6
															: columns === "3"
															? 4
															: 3
													}
													key={item.detail}
												>
													<Box display={"flex"} style={{ gap: 12 }}>
														<CheckCircleIcon
															className={classes.checklistIcon}
															fontSize="large"
														/>
														<Box fontSize={20} lineHeight={1.6}>
															{item.detail}
														</Box>
													</Box>
												</Grid>
											))}
										</Grid>
									</Box>

									{(button || buttonSecondary) && (
										<Box
											mt={"60px !important"}
											className={classes.columnButtonsBox}
											textAlign={textAlign}
											justifyContent={textAlign}
											width={"100%"}
										>
											{button && (
												<Button
													size="large"
													color="primary"
													variant="contained"
													disableElevation
													href={buttonLink}
													className="columnButton"
												>
													{button}
												</Button>
											)}

											{buttonSecondary && (
												<Button
													size="large"
													color="secondary"
													variant="outlined"
													disableElevation
													href={buttonSecondaryLink}
													className="columnButton"
												>
													{buttonSecondary}
												</Button>
											)}
										</Box>
									)}
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteChecklist;
